import { doApiPatch, CallResult } from "./Requests";

export const uploaderApi = {
    uploadServiceModuleIcon: async (serviceModuleId: number, base64Data: string | null): Promise<CallResult<string>> => {
        return await doApiPatch(`/api/companies/current/servicemodules/${serviceModuleId}/icon`,
            base64Data);
    },

    uploadActionModuleIcon: async (actionModuleId: number, base64Data: string | null): Promise<CallResult<string>> => {
        return await doApiPatch(`/api/companies/current/actionmodules/${actionModuleId}/icon`,
            base64Data);
    },

    uploadCalendarEventIcon: async (
        serviceModuleId: number,
        eventId: number,
        base64Data: string | null
    ): Promise<CallResult<string>> => {
        return await doApiPatch(
            `/api/companies/current/servicemodules/calendars/${serviceModuleId}/events/${eventId}/icon`,
            base64Data);
    },
};